module.exports = require("-!babel?optional[]=runtime!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Slider.vue")
module.exports.template = require("-!vue-html!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./Slider.vue")



/*****************
 ** WEBPACK FOOTER
 ** ./src/Slider.vue
 ** module id = 75
 ** module chunks = 0
 **/